import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-50 px-4 py-12 md:px-6 md:py-16" aria-label="常见问题">
      <div className="shell">
      <SectionHeading
        eyebrow="FAQ"
        title="常见问题"
        desc="关于内容来源、可信度分级和投稿方式，这里集中回答最常被问到的几个问题。"
      />

      <div className="mx-auto max-w-3xl divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={item.q}>
              <h3>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                >
                  <span className="flex items-start gap-3">
                    <span className="mt-0.5 font-label text-xs font-black text-primary-500">Q{index + 1}</span>
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  </span>
                  <i
                    className={`flex-shrink-0 text-lg text-foreground-500 transition-transform ${
                      isOpen ? "ri-subtract-line rotate-180 text-primary-500" : "ri-add-line"
                    }`}
                    aria-hidden="true"
                  />
                </button>
              </h3>
              <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96" : "max-h-0"}`}>
                <p className="px-5 pb-5 pl-11 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-12">
                  {item.a}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      </div>
    </section>
  );
}